<template>
    <ds-dropdown
        class="sms-broadcast-options"
        icons
        position="bottom-end"
    >
        <ds-icon-button name="more-vertical" />

        <ul slot="menu" class="dropdown-menu-list">
            <li
                v-if="showEdit"
                class="option dropdown-menu-item"
                data-qa="sms-broadcast-edit"
                @click.prevent="handleEdit"
            >
                <ds-icon class="option-icon" name="edit" />

                <span>{{ $options.MESSAGE_CONSTANTS.EDIT }}</span>
            </li>

            <li
                class="option dropdown-menu-item"
                data-qa="sms-broadcast-copy"
                @click="$emit('copy')"
            >
                <ds-icon class="option-icon" name="copy" />

                <span>{{ $options.MESSAGE_CONSTANTS.COPY }}</span>
            </li>

            <li
                v-if="showStop"
                class="option dropdown-menu-item"
                data-qa="sms-broadcast-stop"
                @click.prevent="$emit('stop')"
            >
                <ds-icon class="option-icon" name="x" />

                <span>{{ $options.MESSAGE_CONSTANTS.STOP }}</span>
            </li>

            <li
                v-if="showResume"
                class="option dropdown-menu-item"
                data-qa="sms-broadcast-resume"
                @click.prevent="$emit('resume')"
            >
                <ds-icon class="option-icon" name="play" />

                <span>{{ $options.MESSAGE_CONSTANTS.RESUME }}</span>
            </li>

            <li
                v-if="showDelete"
                class="option dropdown-menu-item delete"
                data-qa="sms-broadcast-delete"
                @click.prevent="$emit('delete')"
            >
                <ds-icon name="trash-2" />

                <span>{{ $options.MESSAGE_CONSTANTS.DELETE }}</span>
            </li>
        </ul>
    </ds-dropdown>
</template>

<script>
import { SMS_BROADCAST_STATUS } from '../constants/smsBroadcast.constants';
import { showEditForStoppedBroadcast } from '../utils/smsBroadcast.util';

export const MESSAGE_CONSTANTS = {
    COPY: 'Make a copy',
    DELETE: 'Delete',
    STOP: 'Stop sending',
    RESUME: 'Resume sending',
    EDIT: 'Edit',
};
export default {

    SMS_BROADCAST_STATUS,
    MESSAGE_CONSTANTS,

    props: {
        scheduleDate: {
            type: String,
            default: '',
        },
        status: String,
    },

    computed: {
        showDelete() {
            return this.status === SMS_BROADCAST_STATUS.DRAFT;
        },

        showStop() {
            return this.status === SMS_BROADCAST_STATUS.SCHEDULED;
        },

        showResume() {
            return this.status === SMS_BROADCAST_STATUS.STOPPED && !this.isScheduleDateInPast;
        },

        showEdit() {
            return this.status === SMS_BROADCAST_STATUS.DRAFT
                    || (this.status === SMS_BROADCAST_STATUS.STOPPED && this.isScheduleDateInPast);
        },

        isScheduleDateInPast() {
            return showEditForStoppedBroadcast(this.scheduleDate);
        },
    },

    methods: {
        handleEdit() {
            if (this.status === SMS_BROADCAST_STATUS.STOPPED && this.isScheduleDateInPast) {
                this.$emit('resume');
            } else {
                this.$emit('edit');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    $options-min-width: px-to-rem(200px);
    .sms-broadcast-options {
        --dropdown-minwidth: #{$options-min-width};
        align-self: center;
    }

    .sms-broadcast-options .option {
        --icon-color: #{$color-gray-700};
        &.delete {
            --icon-color: #{$color-red};
        }
    }

    .sms-broadcast-options ul.dropdown-menu-list {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
